import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import { Header, ProfileLookerUpper } from '../components/';

export class ProfileBrowser extends Component {
  render() {
    const { profileBrowser, actions } = this.props;
    return (
      <BrandBand>
        <Header route={this.props.match} />
        <div>
          <ProfileLookerUpper
            profileData={profileBrowser.data}
            actions={actions}
          />
        </div>
      </BrandBand>
    );
  }
}

ProfileBrowser.contextTypes = {
  router: PropTypes.object
};

ProfileBrowser.propTypes = {
  profileBrowser: PropTypes.object,
  actions: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    profileBrowser: state.ecs.profileBrowser
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileBrowser);
